import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state: {
        coinRechargeList: [],
        coinExtractList: [],
    },
    getters: {
        coinRechargeList: state => state.coinRechargeList,
        coinExtractList: state => state.coinExtractList
    },
    mutations: {
        setCoinRechargeList(state,payload) {
            state.coinRechargeList = payload;
        },
        setCoinExtractList(state,payload) {
            state.coinExtractList = payload;
        }
    },
    actions: {
        getCoinRechargeList({commit},data) {
            api.getCoinRechargeRemindConfigList(data).then(response =>{
                commit('setCoinRechargeList',response.data);
            })
        },
        getCoinExtractList({commit},data) {
            api.getCoinExtractRemindConfigList(data).then(response =>{
                commit('setCoinExtractList',response.data);
            })
        },
        addCoinRemind({commit},data){
            return api.addCoinRemindConfig(data)
        },
        removeCoinRemind({commit},data){
            return api.removeCoinRemindConfig(data)
        },
        alterCoinRemind({commit},data){
            return api.alterCoinRemindConfig(data);
        },
    }
}

appStore.registerModule('coinRemindSetting', store);
